import { Film } from "lucide-react";
import { fileUrl } from "@/lib/api";

// Lightweight video placeholder — never loads a full <video> in grids.
export function VideoPlaceholder() {
  return (
    <div className="w-full h-full flex items-center justify-center bg-app" data-testid="video-placeholder">
      <Film size={20} strokeWidth={1.5} className="text-subtle" />
    </div>
  );
}

// Thumbnail for calendar/feed grids. Shows cover, image or a light video marker.
export function MediaThumb({ post, emptyLabel = "—" }) {
  const file = post.files?.[0];
  if (post.cover_url) return <img src={fileUrl(post.cover_url)} alt="" className="w-full h-full object-cover" />;
  if (file) {
    if (file.type === "video") return <VideoPlaceholder />;
    return <img src={fileUrl(file.url)} alt="" className="w-full h-full object-cover" />;
  }
  return <div className="w-full h-full flex items-center justify-center bg-surface text-subtle text-xs">{post.type === "texto" ? "Aa" : emptyLabel}</div>;
}
